import React, { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'
import useTapToRefresh from '../Hooks/useTapToRefresh'
import { track } from '../Utils/analytics'
import { t } from '../i18n'
import FeedList from './FeedList'
import { RefreshRow } from './FeedStatus'
import SortTabs from './SortTabs'

/* ?tab=new selects the "Najnovije" tab (spec 3, and what an "Aktuelna tema"
   push links to); "Najčitanije" is the default. Older links' ?prikaz=najnovije
   still works. */
export function useSortParam() {
  const [params, setParams] = useSearchParams()
  const sort = params.get('tab') === 'new' || params.get('prikaz') === 'najnovije' ? 'new' : 'top'
  const setSort = useCallback(
    (value) => {
      const next = new URLSearchParams(params)
      next.delete('prikaz')
      if (value === 'new') next.set('tab', 'new')
      else next.delete('tab')
      setParams(next, { replace: true })
    },
    [params, setParams]
  )
  return [sort, setSort]
}

/* Sticky tabs + feed of a topic, source, category or search (spec 5.6). */
export default function SortedFeed({
  feed,
  sort,
  setSort,
  adSurface,
  empty,
  hideTopic,
  daySeparators,
}) {
  const { row, tap } = useTapToRefresh(feed)
  return (
    <>
      <div className="sticky-bar sticky-under-header">
        <SortTabs
          value={sort}
          onChange={(value) => {
            track('tab_switch', { surface: feed.eventProps().surface, sort: value })
            setSort(value)
          }}
          onReselect={tap}
        />
      </div>
      <RefreshRow state={row} />
      <FeedList
        adSurface={adSurface}
        feed={feed}
        empty={empty}
        hideTopic={hideTopic}
        daySeparators={daySeparators}
      />
    </>
  )
}

export function NotFoundMessage({ text }) {
  return (
    <div className="feed-message">
      <p>{text || t('notFound.title')}</p>
    </div>
  )
}
